import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Select } from 'antd';
import moment from 'moment';

const monthOptions = Array.from({ length: 12 }, (_, i) => ({
  label: `${i + 1}月`,
  value: `${i + 1}`.padStart(2, '0'),
}));

const DatePicker: React.FC<{
  month: string;
  setMonth: React.Dispatch<React.SetStateAction<string>>;
  day: string;
  setDay: React.Dispatch<React.SetStateAction<string>>;
}> = ({ month, setMonth, day, setDay }) => {
  const [dayOptions, setDayOptions] = useState<
    { label: string; value: string }[]
  >([]);
  useEffect(() => {
    const newDayOptions = Array.from(
      { length: moment(month, 'MM').daysInMonth() },
      (_, i) => ({
        label: `${i + 1}日`,
        value: `${i + 1}`.padStart(2, '0'),
      })
    );
    setDayOptions(newDayOptions);
  }, [month]);

  useEffect(() => {
    const allDayOptions = dayOptions.map((opt) => opt.value);
    if (dayOptions.length > 0 && !allDayOptions.includes(day)) {
      setDay('01');
    }
  }, [dayOptions, day, setDay]);
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '80px 80px',
        gap: '8px',
      }}
    >
      <Select
        value={month}
        onChange={(val) => setMonth(val)}
        options={monthOptions}
      />
      <Select
        value={day}
        onChange={(val) => setDay(val)}
        options={dayOptions}
      />
    </Box>
  );
};

export default DatePicker;
